module.exports = __webpack_public_path__ + "static/media/modify.4f08487c.png";